@import '~style-sheet-helpers/core.less';

@new-grey-100: #f9fafb;

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: @new-grey-100;

  & > * {
    align-items: center;
  }

  .footer-right {
    display: flex;
    gap: 8px;
  }
}

.button {
  font-weight: @semi-bold;
  font-size: 13px;
  min-width: 70px;
}

.back-link {
  float: left;
  margin: auto 0;
}
